import React from 'react';
import '../scss/components/_multimedial-panel.scss'
import ReactPlayer from 'react-player';

const Video = (link,paddingClass)=>{
    return(
        <div className={`reactPlayerContainer col-md-6 ${paddingClass || ""}`}>
            <ReactPlayer
                url= {link}
                playing
                loop
                muted
                playsinline
            />
        </div>	
    )
}


const Image = (link,alt) =>{
    return(
    <div className="reactPlayerContainer col-md-6" >
      <img className="shadow-and-radius" src={link} alt="Charthop system preview"/>
    </div>
    )	
}

const Multimedia = (link,type,paddingClass) =>{
    return(
        <React.Fragment>
        {type=="video" ? Video(link,paddingClass) : Image(link) }
        </React.Fragment>
    )
}
const MultimedialPanel = (props)=>{
    return (
        <div className = {`multimediaContainer row py-lg-5 align-items-center ${props.multimediaPosition!="left" ? "reverse":""}`}>
        {props.multimediaPosition=="left" ? Multimedia(props.link,props.type,props.paddingClass):""}
            <div className={`col-md-6  ${props.multimediaPosition=="left" ? "pl-md-2 pl-lg-4" : "pr-md-2 pr-lg-4"}`}>    
                <h2>{props.title}</h2>
                {props.content}
            </div>
        {props.multimediaPosition!="left" ? Multimedia(props.link,props.type,props.paddingClass):""}
        </div>
    )
}

export default MultimedialPanel;